import { useEffect, useState } from "react";

export default function useCounter(target: number, active: boolean, duration = 2000) {
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!active) return;

        let start: number | null = null;
        
        const tick = (ts: number) => {
            if (!start) start = ts;
            const progress = Math.min((ts - start) / duration, 1);
            
            const ease = 1 - Math.pow(1 - progress, 3);

            setN(Math.floor(ease * target));

            if (progress < 1) requestAnimationFrame(tick);

            else setN(target);
        };

        requestAnimationFrame(tick);
    }, [active, target, duration]);

    return n;
}